const strings = {
  heading: 'Short URL Admin',
  createCodeLabel: 'Slug',
  createUrlLabel: 'Target URL',
  createCodePlaceholder: 'my-link',
  createUrlPlaceholder: 'https://example.com/long-url',
  createButton: 'Create',
  editButton: 'Edit',
  editUrlLabel: 'Target URL',
  saveButton: 'Save',
  cancelButton: 'Cancel',
  deleteButton: 'Delete',
  confirmDeleteButton: 'Confirm delete',
  emptyState: 'No short URLs yet.',
  errorLoad: 'Failed to load short URLs.',
  errorCreate: 'Failed to create short URL.',
  errorUpdate: 'Failed to update short URL.',
  errorDelete: 'Failed to delete short URL.',
  errorSlugTaken: 'That slug is already in use.',
  errorInvalidUrl: 'Target must be an absolute http or https URL.',
  searchLabel: 'Search URLs',
  searchPlaceholder: 'Search by slug or URL…',
  searchClearLabel: 'Clear search',
  emptyStateSearch: 'No results match your search.',
  loading: 'Loading…',
  paginationLabel: 'Pagination',
  prevPage: 'Previous page',
  nextPage: 'Next page',
  pageInfo: (page: number, totalPages: number, totalCount: number) =>
    `Page ${page} of ${totalPages} (${totalCount} total)`,
};

export default strings;
